<template>
  <Modal :id="'cmp_royalty_checklist_confirm_royalty'" @cancelled="onCancelClick">
    <template v-if="isLoading" slot="header">
      <template> Confirming Royalty Dates </template>
    </template>
    <template slot="body">
      <div>
        <img v-if="isLoading" src="static/icons/loading.gif" class="v5 s2" />
        <p v-else>
          This Process will take approximately {{ esitmation.mins }} minutes.
          You will receive an email addressed to {{ esitmation.email }} when the
          process has been completed.
        </p>
      </div>
    </template>
    <template slot="options">
      <button v-if="!isLoading" class="dt-button s7" @click="onCancelClick">
        Close
      </button>
      <button class="dt-button s7 v1" @click="onOKClicked">OK</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";
import InputField from "@plugins/text-field/input-field";
import ModalContainer from "@dtplugins/modal/modal-container";
import { statementServices } from "../../services/statements/statements.service";
export default {
  components: {
    Modal,
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,

    //AdvanceSearch,
  },
  data: function () {
    return {
      isLoading: true,
      esitmation: { email: "", mins: 0 },
    };
  },
  mounted: async function () {
    let data =
      await statementServices.confirmAllAccountRoyaltyDatesEstimation();
    this.esitmation = data.data;
    this.isLoading = false;
  },

  mixins: [],

  computed: {},
  methods: {
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onOKClicked:function () {
      
      statementServices.confirmAllAccountRoyaltyDatesV2();
      this.$emit("cancelled", true);
      
    },
  },
};
</script>

<style lang="scss">
.cmp_royalty_checklist_confirm_royalty {
  .dt-modal--header {
    margin: 0 0 20px !important;
  }
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  // .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;

  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>